// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1782":"7a55db95","7047":"7b61e3ea","7898":"7a55db95"}[chunkId] + ".chunk.css";
};